/* Springer Shipping Protection START */

const SPRINGER_PROTECTION_HANDLE = "navidium-shipping-protection";
const SPRINGER_PROTECTION_PRODUCT_URL = "/products/navidium-shipping-protection.js";
const SPRINGER_PROTECTION_MAX = 24.99;

let springerProtectionVariants = null;
let springerProtectionBusy = false;
function springerSetCheckoutDisabled(disabled){
  const buttons = [
    document.getElementById("CartDrawer-Checkout"),
    document.querySelector('button[name="checkout"]')
  ].filter(Boolean);

  buttons.forEach((button)=>{
    button.disabled = disabled;

    if(disabled){
      button.classList.add("springer-checkout-disabled");
    }else{
      button.classList.remove("springer-checkout-disabled");
    }
  });
}
function springerMoney(amount){
  return "$" + amount.toFixed(2);
}

function springerCalculateFee(subtotal){
  let fee = 0;

  if(subtotal < 50){
    fee = 1.99;
  }else if(subtotal < 100){
    fee = 2.99;
  }else if(subtotal < 200){
    fee = subtotal * 0.03;
  }else if(subtotal < 500){
    fee = subtotal * 0.025;
  }else if(subtotal < 1000){
    fee = subtotal * 0.02;
  }else{
    fee = SPRINGER_PROTECTION_MAX;
  }

  return Math.min(fee, SPRINGER_PROTECTION_MAX);
}

async function springerLoadProtectionVariants(){
  if(springerProtectionVariants) return springerProtectionVariants;

  const response = await fetch(SPRINGER_PROTECTION_PRODUCT_URL);
  const product = await response.json();

  springerProtectionVariants = product.variants
    .filter(v => v.available)
    .map(v => ({
      id: v.id,
      price: v.price / 100
    }))
    .sort((a,b) => a.price - b.price);

  return springerProtectionVariants;
}

async function springerFindVariantForFee(fee){
  const variants = await springerLoadProtectionVariants();
  const cappedFee = Math.min(fee, SPRINGER_PROTECTION_MAX);

  let variant = variants.find(v => v.price >= cappedFee);

  if(!variant){
    variant = variants[variants.length - 1];
  }

  if(variant.price > SPRINGER_PROTECTION_MAX){
    variant = variants.filter(v => v.price <= SPRINGER_PROTECTION_MAX).pop();
  }

  return variant;
}

async function springerGetCart(){
  const response = await fetch("/cart.js");
  return response.json();
}

function springerGetProtectionItem(cart){
  return cart.items.find(
    item => item.handle === SPRINGER_PROTECTION_HANDLE
  );
}

function springerGetEligibleSubtotal(cart){
  return cart.items
    .filter(item => item.handle !== SPRINGER_PROTECTION_HANDLE)
    .reduce((sum,item) => sum + item.final_line_price, 0) / 100;
}

async function springerRemoveProtection(cart){
  const protectionItem = springerGetProtectionItem(cart);
  if(!protectionItem) return;

  await fetch("/cart/change.js",{
    method:"POST",
    headers:{ "Content-Type":"application/json" },
    body:JSON.stringify({
      id: protectionItem.key,
      quantity:0
    })
  });

  localStorage.removeItem("springerProtectionSubtotal");
}

function springerIsCartDrawerOpen(){
  const drawer = document.querySelector("cart-drawer");
  return drawer && drawer.getAttribute("aria-hidden") === "false";
}

function springerRenderCart(){
  if(window.eventBus){
    window.eventBus.emit("render:cart:drawer");
  }

  if(
    window.location.pathname === "/cart" &&
    !springerIsCartDrawerOpen()
  ){
    setTimeout(()=>{
      window.location.reload();
    },600);
  }
}

function springerSyncToggles(isChecked){
  const toggles = [
    document.getElementById("springer-protection-toggle"),
    document.getElementById("springer-protection-toggle-cart")
  ].filter(Boolean);

  toggles.forEach(toggle=>{
    toggle.checked = isChecked;
  });
}

async function springerUpdateProtectionDisplay(){
  const priceEls = [
    document.getElementById("springer-protection-price"),
    document.getElementById("springer-protection-price-cart")
  ].filter(Boolean);

  const toggles = [
    document.getElementById("springer-protection-toggle"),
    document.getElementById("springer-protection-toggle-cart")
  ].filter(Boolean);

  if(!priceEls.length && !toggles.length) return;

  const cart = await springerGetCart();
  const protectionItem = springerGetProtectionItem(cart);
  const eligibleSubtotal = springerGetEligibleSubtotal(cart);
  const fee = springerCalculateFee(eligibleSubtotal);
  const variant = await springerFindVariantForFee(fee);

  priceEls.forEach(priceEl=>{
    priceEl.innerText = springerMoney(variant.price);
  });

  toggles.forEach(toggle=>{
    toggle.checked = !!protectionItem;
  });
}

async function springerHandleCartChange(){
  if(springerProtectionBusy) return;

  const cart = await springerGetCart();
  const protectionItem = springerGetProtectionItem(cart);
  const eligibleSubtotal = springerGetEligibleSubtotal(cart);

  const savedSubtotal = parseFloat(
    localStorage.getItem("springerProtectionSubtotal") || "0"
  );

  if(
    protectionItem &&
    savedSubtotal &&
    Math.abs(savedSubtotal - eligibleSubtotal) > 0.01
  ){
    springerProtectionBusy = true;
    springerSetCheckoutDisabled(true);
    await springerRemoveProtection(cart);
    springerRenderCart();

    setTimeout(async ()=>{
      await springerUpdateProtectionDisplay();

      const messages = [
        document.getElementById("springer-protection-message"),
        document.getElementById("springer-protection-message-cart")
      ].filter(Boolean);

      messages.forEach(message=>{
        message.style.display = "block";
      });
      
      springerProtectionBusy = false;
      springerSetCheckoutDisabled(false);
    },800);

    return;
  }

  await springerUpdateProtectionDisplay();
}

document.addEventListener("change", async (e)=>{
  if(
    e.target.id !== "springer-protection-toggle" &&
    e.target.id !== "springer-protection-toggle-cart"
  ) return;

const toggle = e.target;

springerSyncToggles(toggle.checked);

toggle.disabled = true;
springerProtectionBusy = true;
springerSetCheckoutDisabled(true);
  const cart = await springerGetCart();

  if(toggle.checked){
    await springerRemoveProtection(cart);

    const freshCart = await springerGetCart();
    const eligibleSubtotal = springerGetEligibleSubtotal(freshCart);
    const fee = springerCalculateFee(eligibleSubtotal);
    const variant = await springerFindVariantForFee(fee);

    await fetch("/cart/add.js",{
      method:"POST",
      headers:{ "Content-Type":"application/json" },
      body:JSON.stringify({
        items:[
          {
            id: variant.id,
            quantity:1
          }
        ]
      })
    });

    localStorage.setItem(
      "springerProtectionSubtotal",
      eligibleSubtotal.toFixed(2)
    );

  }else{
    await springerRemoveProtection(cart);
  }

  springerRenderCart();

  setTimeout(async ()=>{
    await springerUpdateProtectionDisplay();
    toggle.disabled = false;
    springerSetCheckoutDisabled(false);
    springerProtectionBusy = false;
    
  },800);
});

document.addEventListener("click",()=>{
  setTimeout(springerHandleCartChange,1200);
});

document.addEventListener("DOMContentLoaded",()=>{
  setTimeout(springerHandleCartChange,600);
});

document.addEventListener("drawer:opened",()=>{
  setTimeout(springerHandleCartChange,600);
});

/* Springer Shipping Protection END */

/* Springer Cart Page Auto Update START */

let springerCartUpdateTimer = null;

document.addEventListener("change", function(e){
  if(!e.target.classList.contains("js-qty__num")) return;

  clearTimeout(springerCartUpdateTimer);

  springerCartUpdateTimer = setTimeout(function(){
    const form = e.target.closest("form");
    if(form){
      form.submit();
    }
  }, 600);
});

document.addEventListener("click", function(e){
  if(
    !e.target.closest(".js-qty__adjust--plus") &&
    !e.target.closest(".js-qty__adjust--minus")
  ) return;

  clearTimeout(springerCartUpdateTimer);

  springerCartUpdateTimer = setTimeout(function(){
    const form = e.target.closest("form");
    if(form){
      form.submit();
    }
  }, 800);
});

/* Springer Cart Page Auto Update END */